<template>
  <b-card no-body v-if="actuals">
    <b-card-header>
      <h3 class="mb-0">{{ new Date(actuals.sales_end) | date('Y') }} LISTING STATS</h3>
    </b-card-header>
    <b-row>
      <b-col>
        <b-table responsive small :items="items" :fields="goalFields" foot-clone>
          <template #thead-top="data">
            <b-tr>
              <b-th>{{ new Date(actuals.sales_end) | date('Y') }} QUARTERLY GOALS</b-th>
              <b-th colspan="2" class="text-center">{{ new Date(actuals.sales_start) | date('MMM dd Y') }} &ndash; {{ new Date(actuals.sales_end) | date('MMM dd Y') }}</b-th>
            </b-tr>
          </template>

          <template #cell(quarter)="data">
            <strong>{{ data.item.quarter }}</strong>
          </template>

          <template #cell(appts_held)="data">
            {{ Math.round(totalApptsHeld * (data.item.seasonality / 100)) }}
          </template>

          <template #cell(listings_taken)="data">
            {{ Math.round(totalListingsTaken * (data.item.seasonality / 100)) }}
          </template>

          <template #foot(quarter)="data">
            Totals:
          </template>

          <template #foot(appts_held)="data">
            {{ totalApptsHeld }}
          </template>

          <template #foot(listings_taken)="data">
            {{ totalListingsTaken }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table responsive small :items="actuals.stats" :fields="actualFields" foot-clone>
          <template #thead-top="data">
            <b-tr>
              <b-th>{{ new Date(actuals.sales_end) | date('Y') }} ACTUAL STATS</b-th>
              <b-th colspan="2" class="text-center">{{ new Date(actuals.sales_start) | date('MMM dd Y') }} &ndash; {{ new Date(actuals.sales_end) | date('MMM dd Y') }}</b-th>
            </b-tr>
          </template>

          <template #cell(quarter)="data">
            <strong>{{ data.item.quarter }}</strong>
          </template>

          <template #foot(quarter)="data">
            Totals:
          </template>

          <template #foot(listings_taken)="data">
            {{ listings_taken }}
          </template>

          <template #foot(listings_held)="data">
            {{ listings_held }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    actuals: null,
    items: null,
  },
  data: function() {
    return {
      goalFields: [
        {
          key: 'quarter',
        },
        {
          key: 'appts_held',
          label: 'Listings Held'
        },
        {
          key: 'listings_taken',
          label: 'Listings Taken'
        }
      ],
      actualFields: [
        {
          key: 'quarter'
        },
        {
          key: 'listings_held',
        },
        {
          key: 'listings_taken'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      closedUnits: 'economicModel/closedUnits',
      avgSalePrice: 'economicModel/avgSalePrice',
      totalApptsHeld: 'economicModel/totalApptsHeld',
      totalListingsTaken: 'economicModel/totalListingsTaken'
    }),
    quarter() {
      return this.actuals.quarter - 1;
    },
    closed_sales_volume() {
      return this.closedUnits * Number(this.avgSalePrice);
    },
    seasonality_total() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.seasonality);
      }, 0);
    },
    listings_taken() {
      return this.actuals.stats.reduce(function (total, value) {
        return total + Number(value.listings_taken);
      }, 0);
    },
    listings_held() {
      return this.actuals.stats.reduce(function (total, value) {
        return total + Number(value.listings_held);
      }, 0);
    },
  }
};
</script>